import * as React from 'react'
import { useEffect, useRef, useState } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useSelector } from 'react-redux'
import { Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem, FormHelperText } from '@mui/material'
import { findCode, fullCopy, printVariable } from '@util/helper'
import WebService from '@util/webService'
import useSnackbar from '@hooks/useSnackbar'
import useIndicator from '@hooks/useIndicator'
import axios from 'axios'
import { Fragment } from 'react'
import moment from 'moment'
import { Grid } from '@mui/material/'
import useDelegate from '@hooks/useDelegate'
import { styled } from '@mui/material/styles'

// quill
import ReactQuill, { Quill } from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import 'react-quill/dist/quill.bubble.css'

const TeacherAttdncPartNoti = ({ genBings, topicCode, chgBings, dialogHandler, onSendMessage, callback }) => {
  const data = genBings()
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const [statGroup, set_statGroup] = useState({})
  const [chgGroup, set_chgGroup] = useState({})

  // redux
  const codes = useSelector((state) => state.codeReducer)
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const editorRef = useRef()

  const statCodeList = codes.filter((r) => r.codeGroupId === 'SA10' && r.code.startsWith('S')).filter((r) => r.code !== 'S000')
  const chgCodeList = codes.filter((r) => r.codeGroupId === 'SB10')

  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    } else {
      dialogHandler[1](false)
    }
  }

  const groupByCode = (codeName) => {
    const gByCode = {}
    const codeList = codeName === 'statCode' ? statCodeList : codeName === 'chgCode' ? chgCodeList : []

    codeList.forEach((code) => {
      const list = gByCode[code.code] ?? []
      data.forEach((d) => {
        if (codeName === 'statCode') {
          if (d.statCode === code.code) {
            list.push(d)
          }
        } else if (codeName === 'chgCode') {
          // !! bingId 와 id 를 비교함에 주의
          if (d.chgCode === code.code && code.code !== 'C000' && chgBings.findIndex((r) => r.bingId === d.id) >= 0) {
            list.push(d)
          }
        }
      })
      gByCode[code.name] = list
    })

    if (codeName === 'statCode') {
      set_statGroup(gByCode)
    } else if (codeName === 'chgCode') {
      set_chgGroup(gByCode)
    }
  }

  useEffect(() => {
    groupByCode('statCode')
    groupByCode('chgCode')
  }, [])

  return (
    <Fragment>
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle style={{ justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant="h5" align="center" style={{ fontWeight: 'bold' }}>
            {topicCode === 'TP02' ? '출결' : topicCode === 'TP10' ? '이동' : '종료'}
            <span> 알림전송</span>
          </Typography>
          <Divider />
        </DialogTitle>
        <DialogContent>
          {topicCode === 'TP02' ? (
            <>
              <Grid container>
                {Object.keys(statGroup).map((item, index) =>
                  statGroup[item].length > 0 ? (
                    <>
                      <Grid item xs={12}>
                        <Grid container>
                          <Grid item xs={6}>
                            {item}: {statGroup[item]?.length}
                          </Grid>
                          <Grid item xs={6}>
                            <Grid container>
                              {statGroup[item].map((bing, index2) => (
                                <Grid item xs={12}>
                                  <Typography>
                                    {bing.studentName}({bing.grade}/{bing.className}/{bing.classNum})
                                  </Typography>
                                </Grid>
                              ))}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider style={{borderColor:'#f0f0f0'}}/>
                      </Grid>
                    </>
                  ) : null
                )}
              </Grid>
            </>
          ) : topicCode === 'TP10' ? (
            <>
              <Grid container>
                {Object.keys(chgGroup).map((item, index) =>
                  chgGroup[item].length > 0 ? (
                    <>
                      <Grid item xs={12}>
                        <Grid container>
                          <Grid item xs={6}>
                            {item}: {chgGroup[item]?.length}
                          </Grid>
                          <Grid item xs={6}>
                            <Grid container>
                              {chgGroup[item].map((bing, index2) => (
                                <Grid item xs={12}>
                                  <Typography>
                                    {bing.studentName}({bing.grade}/{bing.className}/{bing.classNum})
                                  </Typography>
                                </Grid>
                              ))}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider style={{borderColor:'#f0f0f0'}}/>
                      </Grid>
                    </>
                  ) : null
                )}
              </Grid>
            </>
          ) : topicCode === 'TP03' ? (
            <Grid container>
              <Grid itme xs={12} style={{display:'flex', justifyContent:'center'}}>
                <Typography>
                  학생 수: {data.length}
                </Typography>
                
              </Grid>
            </Grid>
          ) : null}
          <div style={{display:'flex', justifyContent:'center', marginTop:50}}>
            <Typography>
              위와 같이 보호자에게 알림이 전송되고 출석부에 일괄 저장됩니다.
            </Typography>
          </div>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button onClick={handleClose}>닫기</Button>
          <Button variant="contained" onClick={() => {
            onSendMessage()
          }}>
            확인
          </Button>
        </DialogActions>
      </Dialog>
      {renderSnackbar()}
      {renderIndicator()}
    </Fragment>
  )
}

export default TeacherAttdncPartNoti
